import React from 'react';
import { Helmet } from 'react-helmet';

interface IProp {
  title?: string;
  description?: string;
}

const PROJECT_NAME = 'WoodFlow EUDR';

const Metatag = ({ title, description }: IProp): React.ReactElement => (
  <Helmet>
    <meta charSet="utf-8" />
    <title>{`${PROJECT_NAME} `}</title>
    {description && <meta name="description" content={description} title={title} />}
  </Helmet>
);

Metatag.defaultProps = { title: '', description: '' };

export default Metatag;
